var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3813 4.83081C17.058 4.50082 16.5336 4.50082 16.2103 4.83081L8.01252 13.1958L4.20643 9.31206C3.88303 8.98207 3.3587 8.98207 3.03533 9.31206L2.74253 9.61081C2.41916 9.9408 2.41916 10.4758 2.74253 10.8058L7.13418 15.2871L7.42695 15.5858C7.75035 15.9158 8.27468 15.9158 8.59806 15.5858L8.89083 15.2871L17.6741 6.32456C17.9975 5.99457 17.9975 5.45955 17.6741 5.12956L17.3813 4.83081Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.459e9d4a2169e254a044df05eedae1df.svg";
export { ForwardRef as ReactComponent };